import { SalesPage } from './pages/sales/SalesPage.js';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { I18nProvider } from './i18n/I18nContext.js';
import { RequireAuth } from './auth/RequireAuth.js';
import { LoginPage } from './auth/LoginPage.js';
import { Layout } from './components/Layout.js';
import { ProductsPage } from './pages/products/ProductsPage.js';
import { CategoriesPage } from './pages/categories/CategoriesPage.js';
import { DiscountReasonsPage } from './pages/discountReasons/DiscountReasonsPage.js';
import { StaffPage } from './pages/staff/StaffPage.js';
import { TerminalsPage } from './pages/terminals/TerminalsPage.js';
import { PaymentTerminalsPage } from './pages/paymentTerminals/PaymentTerminalsPage.js';
import { ReportsPage } from './pages/reports/ReportsPage.js';
import { ShiftsPage } from './pages/shifts/ShiftsPage.js';
import { SyncHealthPage } from './pages/sync/SyncHealthPage.js';
import { TicketPage } from './pages/ticket/TicketPage.js';

export function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <RequireAuth>
                <Layout />
              </RequireAuth>
            }
          >
            <Route index element={<Navigate to="/products" replace />} />
            <Route path="products" element={<ProductsPage />} />
            <Route path="categories" element={<CategoriesPage />} />
            <Route path="discount-reasons" element={<DiscountReasonsPage />} />
            <Route path="staff" element={<StaffPage />} />
            <Route path="terminals" element={<TerminalsPage />} />
            <Route path="payment-terminals" element={<PaymentTerminalsPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="sales" element={<SalesPage />} />
            <Route path="shifts" element={<ShiftsPage />} />
            <Route path="sync" element={<SyncHealthPage />} />
            <Route path="ticket" element={<TicketPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </I18nProvider>
  );
}
